import { format, setDate } from "date-fns";
import { useState } from "react";
import { Button, ButtonGroup, Container } from "reactstrap";
import { useGetReportNikolasQuery } from "../../features/CallApi";
import LoadScreen from "../UI/LoadScreen";
import useToken from "../useToken";
import { TypeOfPay } from "../Orders/OrderTypeOfPay";
import { PaymentsType } from "./PaymentsType";


export const RoportsNikolas = () => {
    // const [startDate, setStartDate] = useState(format(new Date(Date.now()), "yyyy-MM-dd"))
    const [startDate, setStartDate] = useState(format(new Date(Date.now()), "yyyy-MM-dd") + "T00:00")
    const [endDate, setEndDate] = useState(format(new Date(Date.now()), "yyyy-MM-dd") + "T23:59")
    const { token, role } = useToken();


    const { data, isLoading } = useGetReportNikolasQuery({ startDate, endDate })

    const getReportOfClientsExcelNikolas = () => {
        fetch(`/api/reportsservice/nikalasreportorderstoexcel/?startDate=${startDate}&endDate=${endDate}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }).then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Report_Of_Clients" + startDate + "_" + endDate + ".xlsx";
                link.click();
            })
            .catch(console.error);
    }


    return (
        <Container fluid>
            <div>
                <div>
                    <div className="d-inline-flex mt-3 mb-3 input-group">
                        <div className="me-1">
                            <div className="form-floating">
                                <input
                                    type="datetime-local"
                                    className="form-control"
                                    id="startDate"
                                    name="startDate"
                                    onChange={
                                        (e) => {
                                            setStartDate(e.target.value)
                                        }
                                    }
                                    defaultValue={format((new Date(Date.now()) - 1), "yyyy-MM-dd") + "T00:00"} />
                                <label htmlFor="startDate">С</label>
                            </div>
                        </div>
                        <div>
                            <div className="form-floating">
                                <input
                                    type="datetime-local"
                                    className="form-control"
                                    id="endDate"
                                    name="endDate"
                                    onChange={
                                        (e) => {
                                            setEndDate(e.target.value)
                                        }
                                    }
                                    defaultValue={format(new Date(Date.now()), "yyyy-MM-dd") + "T23:59"} />
                                <label htmlFor="endDate">По</label>
                            </div>
                        </div>
                        <ButtonGroup className="ms-1">
                            {/* <Button className="text-white" color="success" onClick={() => { getItem() }}>Поиск</Button> */}
                            {/* <Button className="text-white" color="info" onClick={() => getReportExcelIgora()}>Сохранить в Excel</Button> */}
                            <Button className="text-white" color="info" onClick={() => getReportOfClientsExcelNikolas()}>Сохранить в Excel</Button>
                        </ButtonGroup>

                    </div>
                </div>
            </div>
            <div>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                Название шоу
                            </th>
                            <th>
                                Дата
                            </th>
                            <th>
                                Время
                            </th>
                            <th>
                                Номер заказа
                            </th>
                            <th>
                                Время оплаты
                            </th>
                            <th>
                                Ряд
                            </th>
                            <th>
                                Место
                            </th>
                            <th>Цена</th>
                            <th>ФИО гостя</th>
                            <th>Примечание</th>
                            <th>Платежный сервис</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? <>
                            {!isLoading ?
                                <>
                                    {data.map(item =>
                                        <tr key={item.id}>
                                            <td>
                                                {item.eventName}
                                            </td>
                                            <td>
                                                {format(new Date(item.eventDate), "dd.MM.yyyy")}
                                            </td>
                                            <td>
                                                {format(new Date(item.eventDate), "HH:mm")}
                                            </td>
                                            <td>
                                                {item.orderId}
                                            </td>
                                            <td>
                                                {format(new Date(item.createOrderTime), "dd.MM.yyyy HH:mm")}
                                            </td>
                                            <td>{item.row}</td>
                                            <td>{item.place}</td>
                                            <td>{item.price}</td>
                                            <td>{item.client.lastName} {item.client.firstName}</td>
                                            <td>{item.client.email}</td>
                                            <td>
                                                {item.payService}
                                            </td>
                                        </tr>
                                    )
                                    }
                                </>
                                : <LoadScreen />}
                        </> :
                            <tr><td colSpan={11} className="text-center mt-5 mb-5"><strong>Список пуст</strong></td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </Container>
    );
}